import { ChangeDetectionStrategy, Component, computed, input, model, output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { PaymentMode, PaymentModesIcons, SelectedPaymentMode } from '@checkout-v2/const';
import { BankCard, PaymentModeCodes } from '@payment/const';
import { SdvorIconComponent, SdvorRadioComponent } from '@sdvor/shared/ui/v2';
import { IconTypes } from '@shared/v2';

@Component({
  selector: 'sd-payment-modes-list',
  templateUrl: './payment-modes-list.component.html',
  styleUrls: ['./payment-modes-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [FormsModule, SdvorRadioComponent, SdvorIconComponent],
})
export class PaymentModesListComponent {
  readonly paymentModesList = input.required<PaymentMode[]>();
  readonly bankCardsList = input.required<BankCard[]>();
  readonly canPayInplace = input.required<boolean>();
  readonly bindNewCardClicked = output();
  readonly activePaymentMode = model.required<SelectedPaymentMode | undefined>();

  private readonly paymentModeCodes = PaymentModeCodes;
  protected readonly iconTypes = IconTypes;

  protected readonly sbrfItem = computed(() => {
    const items = this.paymentModesList();

    return items.find((item) => item.code === this.paymentModeCodes.Sbrf);
  });

  protected readonly otherItems = computed(() => {
    const items = this.paymentModesList();

    return items.filter((item) => item.code !== this.paymentModeCodes.Sbrf);
  });

  protected onBindNewCardClicked(): void {
    this.bindNewCardClicked.emit();
    this.activePaymentMode.set(undefined);
  }

  protected getIcon(paymentModeCode: PaymentModeCodes): IconTypes {
    const icon = PaymentModesIcons[paymentModeCode];

    return icon ?? IconTypes.CARD;
  }

  protected formatBankCard(card: BankCard): SelectedPaymentMode {
    const sbrfItem = this.sbrfItem() as PaymentMode;

    return {
      ...sbrfItem,
      bindingId: card.bindingId,
    };
  }
}
